import { i18n } from './i18n';

/**
 * Estado de un evento en las listas de actividad. Si su expediente está «En espera» (solo gdp) el SAC ya cerró la
 * alerta y el evento llega CLOSED, pero el caso sigue abierto: se enseña «En espera» en la misma columna.
 */
export const eventStateLabel = (item: any): string =>
  item?.expedientWaiting ? i18n('expedient.dialog.state.waiting') : i18n(item?.eventState);
